import React from 'react';
import './TestimonialsSection.css';
import testimonial1 from "../assets3/testimonial1.jpg";
import testimonial2 from "../assets3/testimonial2.jpg";
import testimonial3 from "../assets3/testimonial3.jpg";

// Reuseable lightweight SVG Star element matching the royal blue brand identity
const StarIcon = () => (
  <svg className="jabh-testi-star" viewBox="0 0 24 24" fill="#0056b3" width="18" height="18">
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
  </svg>
);

const TestimonialsSection = () => {
  const testimonialsData = [
  {
    id: 1,
    title: "Highly recommended for machine repairs!",
    comment: "Our top-load washing machine started leaking water from the bottom during cycles. The technician from Jay Ambe Washing Machine Services arrived promptly, diagnosed a cracked drain pipe, and swapped it out on the spot. Very clean, honest work and reasonable charges.",
    name: "Rajesh Sharma",
    image: testimonial1
  },
  {
    id: 2,
    title: "Excellent washing machine repair",
    comment: "My front-load washing machine was making an unbearable vibrating noise during the spin cycle. Their expert diagnosed a drum alignment issue and replaced the faulty part on the spot. It runs smoothly and quietly now. Truly hassle-free doorstep service!",
    name: "Neha Patel",
    image: testimonial2
  },
  {
    id: 3,
    title: "Fast, professional, and reliable",
    comment: "The spinner on our semi-automatic washer completely stopped spinning. Their technician checked it thoroughly, replaced a faulty capacitor, and serviced the motor mechanism. Honest pricing, no hidden fees, and highly professional work. Will definitely use them again!",
    name: "Amit Verma",
    image: testimonial3
  }
];

  return (
    <section className="jabh-testi-section">
      <div className="jabh-testi-container">
        
        {/* Section Heading Group */}
        <div className="jabh-testi-header">
          <span className="jabh-testi-sub">TESTIMONIALS</span>
          <h2 className="jabh-testi-main-title">What Our Clients Say</h2>
        </div>

        {/* Testimonials Review Grid Layout */}
        <div className="jabh-testi-grid">
          {testimonialsData.map((item) => (
            <div key={item.id} className="jabh-testi-card">
              
              {/* Star Row Rating */}
              <div className="jabh-testi-stars-row">
                <StarIcon />
                <StarIcon />
                <StarIcon />
                <StarIcon />
                <StarIcon />
              </div>

              {/* Review Text Area */}
              <h3 className="jabh-testi-card-title">{item.title}</h3>
              <p className="jabh-testi-card-comment">“{item.comment}”</p>

              {/* Client Profile Identity Block */}
              <div className="jabh-testi-profile">
                <img 
                  src={item.image} 
                  alt={item.name} 
                  className="jabh-testi-avatar" 
                />
                <span className="jabh-testi-name">{item.name}</span>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TestimonialsSection;